import { render, staticRenderFns } from "./EkDialog.vue?vue&type=template&id=3a8f4bac&scoped=true&"
import script from "./EkDialog.vue?vue&type=script&lang=js&"
export * from "./EkDialog.vue?vue&type=script&lang=js&"
import style0 from "./EkDialog.vue?vue&type=style&index=0&id=3a8f4bac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8f4bac",
  null
  
)

export default component.exports